import { ActionTypes } from './types';
import { ThunkResult } from '../../types';

export const statementAnswerIsSelected = (questionId: string, answerId: string, isCorrect: boolean): ThunkResult => dispatch => {
  dispatch({
    type: ActionTypes.QUESTION_STATEMENT_ANSWER_IS_SELECTED,
    payload: { questionId, answerId, isCorrect }
  });
};
